const namespaced = true

const state = {
  eventName:'',
  eventLocation:null,
  arnSiteId: null,
  protectGroupEnabled: true,
  protectGroupPremium: 0,
  formCurrency: 'USD',
  formRate: 1.0,
}

const mutations = {
  updateEventLocation(state, location) { // Namespaced
    state.eventLocation = location
  },
  updateArnSiteId(state, id) { // Namespaced
    state.arnSiteId = id
  },
}

export default {
  namespaced,
  state,
  mutations,
}
